// extracted by mini-css-extract-plugin
module.exports = {"pricing":"Pricing-module--pricing--MRhvG","title":"Pricing-module--title--3B_8X","prices":"Pricing-module--prices--1Dd0L","modal":"Pricing-module--modal--1qVfN"};